<svelte:options immutable/>
<script lang="ts">
  import {
    Button,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    CardSubtitle,
    CardText,
    CardTitle,
    Container,
    Row,
    Col,
  } from "sveltestrap"
  import Image from "./Image.svelte"
  import { Link } from "svelte-routing"
  import { nFormatter, Pair } from "../utils/utils"
  import { tokenPrice } from "../stores/store"

  export let pair: Pair;

  let apy = pair.yearPairRewardPerRound * $tokenPrice.PIL / (pair.roundTokenPrice * $tokenPrice[pair.denominator.symbol]) * 100;
</script>

<Col>
  <Link to="/nft/{pair.id}" state={{pair: Object.assign({}, pair)}}>
<Card class="mb-3 nftCard" xs="12" sm="3">
  <Image src={pair.imageUrl} />
  <CardBody class="nftCard-body">
    <CardSubtitle class="nftCard-collection">{pair.collection}</CardSubtitle>
    <CardTitle class="nftCard-title">{pair.title}</CardTitle>
  </CardBody>
  <CardFooter class="nftCard-footer">
    <Row>
      <Col class="nftCard-label-apy">
        PIL APR
      </Col>
      <Col class="nftCard-apy">
        {apy.toFixed(2)}%
      </Col>
    </Row>
  </CardFooter>
  <CardFooter class="nftCard-footer nftCard-priceFooter">
    <Row>
      <Col>
        <div class="nftCard-label">Round</div>
        <div>
          <span class="nftCard-price">
            {#if pair.roundTokenPrice < 0.01}
              {nFormatter(pair.roundTokenPrice * 1000000, 2)}
            {:else}
              {nFormatter(pair.roundTokenPrice, 2)}
            {/if}
          </span>
          <span class="nftCard-unit">
            {#if pair.roundTokenPrice < 0.01}
              μ{pair.denominator.symbol}
            {:else}
              {pair.denominator.symbol}
            {/if}
          </span>
        </div>
        <div class={`nftCard-price-delta ${pair.roundPriceChange >= 0 ? 'positive' : 'negative'}`}>
          {pair.roundPriceChange >= 0 ? '+' : '-'} {nFormatter(pair.roundPriceChange, 2)}% 24h
        </div>
      </Col>
      <Col>
        <div class="nftCard-label">NFT</div>
        <div>
          <span class="nftCard-price">
            {nFormatter(pair.nftPrice, 2)}
          </span>
          <span class="nftCard-unit">
            {pair.denominator.symbol}
          </span>
        </div>
        <div class={`nftCard-price-delta ${pair.nftPriceChange >= 0 ? 'positive' : 'negative'}`}>
          {pair.nftPriceChange >= 0 ? '+' : '-'} {nFormatter(pair.nftPriceChange, 2)}% 24h
        </div>
      </Col>
    </Row>
  </CardFooter>
</Card>
  </Link>
</Col>
